import React from 'react';
import { TTestResult } from '../../../store/interactive/types';
import { ChartView } from '../../Chart';

interface TestProps {
  testResult: TTestResult;
}

export const TestResult: React.FC<TestProps> = React.memo(({testResult}) => {
    const dataOption = testResult.columns.map(item => {
        return item.value;
    });

    const maxValue = Math.max(...dataOption);

    const labels = testResult.columns.map(item => {
        return String(item.pos);
    });
    const data = {
            labels: labels,
            datasets: [
                {
                    label: 'Учасники',
                    data: dataOption,
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)',
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)',
                    ],
                    borderWidth: 1,
                },
            ],
        };
    const scales = {
            x: {
                title: {
                    color: 'black',
                    display: true,
                    text: 'Бали'
                }
            },
            y: {
                title: {
                    color: 'black',
                    display: true,
                    text: 'Учасники'
                },
                min: 0,
                max: maxValue > 3 ? maxValue : 3,
                ticks: {
                    precision: 0
                }
            }
        }
    return <div style={{padding: '20px 50px'}}>
        <h1 style={{textAlign: 'center'}}>Результати тестів</h1>
        <h2 style={{textAlign: 'center'}}>{`Тема. ${testResult.title}`}</h2>
        <ChartView type={'bar'} scales={scales} legend={false} data={data}/>
    </div>
});

